// @ts-nocheck
import * as React from 'react';
import $ from 'jquery';
import 'jquery.cookie';
import logo2 from '../../images/login_bg1.jpg';
import OrbcommLogo11 from '../../images/ORBCOMMLOGOR.svg';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { ResetPassword } from '../sharedcomponents/ResetPassword';
import SignIn from '../../images/Microsoft_SignIn.png';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import { RCUtils } from './../../RCUtils';

import { PublicClientApplication } from '@azure/msal-browser';


var Config: any = require('../../Config.json');

interface UserLoginState {
    Username: string;
    Password: string;
    IsLoggedIn: boolean;
    LoginAttempts: number;
    IsAccountLocked: boolean;
    showResetPasswordComponent: boolean;
    renderResetPasswordHtml: any;
    isLoading: boolean;
    loggedInUserData: server.UserLoginDetails;
}

// At runtime, Redux will merge together...
//type UserDetailProps =
//    UserDetailState.UserState        // ... state we've requested from the Redux store
//    & typeof UserDetailState.actionCreators      // ... plus action creators we've requested
//    & RouteComponentProps<{}>; // ... plus incoming routing parameters

export default class UserLogin extends React.Component<any, UserLoginState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Username: '',
            Password: '',
            IsLoggedIn: false,
            LoginAttempts: 0,
            IsAccountLocked: false,
            showResetPasswordComponent: false,
            renderResetPasswordHtml: '',
            isLoading: true,
            loggedInUserData: []

        };
        //if (sessionStorage.getItem("UserInfo") != null && sessionStorage.getItem("UserInfo") != undefined) {
        //    this.props.history.push('/home');
        //}
    }

    UsernameChange(event: React.FormEvent<HTMLInputElement>) {
        var userid = this.state.Username;
        var Value: string = event.currentTarget.value;
        userid = Value;
        this.setState({
            Username: userid
        });
    }

    PasswordChange(event: React.FormEvent<HTMLInputElement>) {
        var userPassword = this.state.Password;
        var Value: string = event.currentTarget.value;
        userPassword = Value;
        this.setState({
            Password: userPassword
        });
    }
    handlePassword(event: React.FormEvent<HTMLInputElement>) {
        var IsCheck: boolean = $("#spanPassword").hasClass("fas fa-eye-slash");
        if (IsCheck) {
            $('#spanPassword').removeClass('fas fa-eye-slash');
            $('#spanPassword').addClass('fas fa-eye');
        }
        else {
            $('#spanPassword').removeClass('fas fa-eye');
            $('#spanPassword').addClass('fas fa-eye-slash');
        }

        if ($("#spanPassword").hasClass("fas fa-eye")) {

            const password = document.querySelector("#txtPassWord");
            const type = "text";
            password.setAttribute("type", type);
        }
        else {
            const password = document.querySelector("#txtPassWord");
            const type = "password";
            password.setAttribute("type", type);

        }
    }
    cookieStore() {
        if ($('input[name="remember"]').is(':checked')) {
            var uname = $('#txtUserName').attr("value");
            //var pword = $('#txtPassWord').attr("value"); //RCNG-131
            // set cookies to expire in 14 days            
            $.cookie('uname', uname, { expires: 30, path: '/' });
            //$.cookie('pword', pword, { expires: 30, path: '/' }); //RCNG-131
            $.cookie('pword', '', { path: '/' }); //RCNG-131 
            $.cookie('remember', true, { expires: 30, path: '/' });
        }
        else {
            // reset cookies
            $.cookie('uname', null, { path: '/' });
            $.cookie('pword', null, { path: '/' });
            //$.removeCookie("uname");
            $.cookie('remember', null, { path: '/' });
        }

    }

    async SignInWithAzureAD() {
        $('#globalLoader').show();
        const loginRequest = {
            scopes: ["api://" + Config.AzurereApiclientId + "/access_rc", "email"],
        };
        const clientConfig = {
            auth: {
                clientId: Config.AzureclientId,
                authority: Config.Azureauthority,
                redirectUri: Config.AzureredirectUri,
                navigateToLoginRequestUrl: true,
                cache: {
                    cacheLocation: "localStorage",
                    storeAuthStateInCookie: false
                },
                system: {
                    windowHashTimeout: 60000, // set timeout to 60 seconds
                    iframeHashTimeout: 60000,
                    loadFrameTimeout: 60000,
                    popupTimeout: 60000,
                    tokenAcquisitionTimeout: 60000,
                    asyncPopups: false
                }
            }

        }
        const msalInstance = new PublicClientApplication(clientConfig);
        try {
            const loginResponse = await msalInstance.ssoSilent(loginRequest).then(
                function (accessTokenResponse) {
                    if (accessTokenResponse.accessToken != "") {
                        if (accessTokenResponse.idTokenClaims != undefined && accessTokenResponse.idTokenClaims != "" && accessTokenResponse.idTokenClaims.given_name != undefined && accessTokenResponse.idTokenClaims.given_name != "") {
                            sessionStorage.setItem('AZUName', accessTokenResponse.idTokenClaims.given_name);
                        }
                        let accessToken = accessTokenResponse.accessToken;
                        sessionStorage.setItem('JWTToken', accessToken);
                        var url = Config.ApiBaseUrl + '/api/AuthUser/ValidateAzureADUser';
                        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleOktaError)
                            .then(response => response.json() as Promise<server.UserLoginDetails>)
                            .then(data => {
                                if (data.Errmsg == null || data.Errmsg == "") {
                                    var userDetailInfo = JSON.parse(JSON.stringify(data));
                                    if (userDetailInfo != null && userDetailInfo.User != null && userDetailInfo.User != undefined) {
                                        sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                                        localStorage.setItem('login_status', 'logged_in' + '&' + JSON.stringify(userDetailInfo.User.UserName));
                                        sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                                        var userInfo = JSON.stringify({
                                            'Username': userDetailInfo.User.UserName, 'IsAccountLocked': userDetailInfo.IsAccountLocked, 'IsLoggedIn': true,
                                            'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                            'LoginAttempts': userDetailInfo.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd,
                                            'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                            'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                            'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
                                            'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'AzureSignInOverrideOption': userDetailInfo.User.AzureSignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                            'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                                        });
                                        sessionStorage.setItem('UserInfo', userInfo);

                                        if (userDetailInfo.User.Customer.AzureSignInOption == "D") {
                                            PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                            $('#globalLoader').hide();
                                            if (localStorage.length > 0) {
                                                localStorage.clear();
                                            }
                                            if (sessionStorage.length > 0) {
                                                sessionStorage.clear();
                                            }
                                            return;
                                        } else if (userDetailInfo.User.AzureSignInOverrideOption == "D") {
                                            PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                            $('#globalLoader').hide();
                                            if (localStorage.length > 0) {
                                                localStorage.clear();
                                            }
                                            if (sessionStorage.length > 0) {
                                                sessionStorage.clear();
                                            }
                                            return;
                                        } else {
                                            window.location.href = "/adlogin";
                                        }
                                    } else {
                                        $('#globalLoader').hide();
                                        if (localStorage.length > 0) {
                                            localStorage.clear();
                                        }
                                        if (sessionStorage.length > 0) {
                                            sessionStorage.clear();
                                        }
                                        //$('#globalLoader').hide();
                                        var loader = document.getElementById("preloader");
                                        loader.classList.add("hidden");
                                        PopupWindow.showErrorMessage("Login", "User data not match with Maritime platform data.Please contact Orbcomm suport team for further information.");
                                        return;
                                    }
                                }
                                else {
                                    $('#globalLoader').hide();
                                    var loaderimg = document.getElementById("preloader");
                                    loaderimg.classList.add("hidden");
                                    PopupWindow.showErrorMessage("Login", data.Errmsg);
                                }
                            }).catch((error) => {
                                $('#globalLoader').hide();
                                console.log("error" + error);
                                this.HandelInteractionErrorbyMicrosoft(error);
                                // error.errorMessage == 'User cancelled the flow.' ? PopupWindow.showErrorMessage("Login", "User cancelled the 'Sign in with Microsoft' flow.") : PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
                            });
                    }

                }
            );
        } catch (error) {
            console.log("interaction-error by Microsoft:" + error);
            if (
                error.errorCode.indexOf("consent_required") > -1 ||
                error.errorCode.indexOf("monitor_window_timeout") > -1 ||
                error.errorCode.indexOf("popup_window_error") > -1 ||
                error.errorCode.indexOf("interaction_required") > -1 ||
                error.errorCode.indexOf("login_required") > -1
            ) {
                //if (error instanceof InteractionRequiredAuthError) {
                const loginResponse = await msalInstance.loginPopup(loginRequest).then(
                    function (accessTokenResponse) {
                        if (accessTokenResponse.accessToken != "") {
                            if (accessTokenResponse.idTokenClaims != undefined && accessTokenResponse.idTokenClaims != "" && accessTokenResponse.idTokenClaims.given_name != undefined && accessTokenResponse.idTokenClaims.given_name != "") {
                                sessionStorage.setItem('AZUName', accessTokenResponse.idTokenClaims.given_name);
                            }
                            let accessToken = accessTokenResponse.accessToken;
                            sessionStorage.setItem('JWTToken', accessToken);
                            var url = Config.ApiBaseUrl + '/api/AuthUser/ValidateAzureADUser';
                            var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleOktaError)
                                .then(response => response.json() as Promise<server.UserLoginDetails>)
                                .then(data => {
                                    if (data.Errmsg == null || data.Errmsg == "") {
                                        var userDetailInfo = JSON.parse(JSON.stringify(data));
                                        if (userDetailInfo != null && userDetailInfo.User != null && userDetailInfo.User != undefined) {
                                            sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                                            localStorage.setItem('login_status', 'logged_in' + '&' + JSON.stringify(userDetailInfo.User.UserName));
                                            sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                                            var userInfo = JSON.stringify({
                                                'Username': userDetailInfo.User.UserName, 'IsAccountLocked': userDetailInfo.IsAccountLocked, 'IsLoggedIn': true,
                                                'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                                'LoginAttempts': userDetailInfo.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd,
                                                'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                                'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                                'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
                                                'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'AzureSignInOverrideOption': userDetailInfo.User.AzureSignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                                'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                                            });
                                            sessionStorage.setItem('UserInfo', userInfo);

                                            if (userDetailInfo.User.Customer.AzureSignInOption == "D") {
                                                PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                                $('#globalLoader').hide();
                                                if (localStorage.length > 0) {
                                                    localStorage.clear();
                                                }
                                                if (sessionStorage.length > 0) {
                                                    sessionStorage.clear();
                                                }
                                                return;
                                            } else if (userDetailInfo.User.AzureSignInOverrideOption == "D") {
                                                PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                                $('#globalLoader').hide();
                                                if (localStorage.length > 0) {
                                                    localStorage.clear();
                                                }
                                                if (sessionStorage.length > 0) {
                                                    sessionStorage.clear();
                                                }
                                                return;
                                            } else {
                                                window.location.href = "/adlogin";
                                            }
                                        } else {
                                            //$('#globalLoader').hide();
                                            if (localStorage.length > 0) {
                                                localStorage.clear();
                                            }
                                            if (sessionStorage.length > 0) {
                                                sessionStorage.clear();
                                            }
                                            $('#globalLoader').hide();
                                            var loader = document.getElementById("preloader");
                                            loader.classList.add("hidden");
                                            PopupWindow.showErrorMessage("Login", "User data not match with Maritime platform data.Please contact Orbcomm support team for further information.");
                                            return;
                                        }
                                    }
                                    else {
                                        $('#globalLoader').hide();
                                        var loaderimg = document.getElementById("preloader");
                                        loaderimg.classList.add("hidden");
                                        PopupWindow.showErrorMessage("Login", data.Errmsg);
                                    }
                                }).catch((error) => {
                                    $('#globalLoader').hide();
                                    console.log("error" + error);
                                    this.HandelInteractionErrorbyMicrosoft(error);
                                    // error.errorMessage == 'User cancelled the flow.' ? PopupWindow.showErrorMessage("Login", "User cancelled the 'Sign in with Microsoft' flow.") : PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
                                });
                        }

                    }).catch(error => {
                        $('#globalLoader').hide();
                        console.log("error" + error);
                        this.HandelInteractionErrorbyMicrosoft(error);
                        //error.errorMessage == 'User cancelled the flow.' ? PopupWindow.showErrorMessage("Login", "User cancelled the 'Sign in with Microsoft' flow.") : PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
                    });
            } else {
                if (error != null && error != undefined && error != '') {
                    $('#globalLoader').hide();
                    console.log("error" + error);
                    this.HandelInteractionErrorbyMicrosoft(error);
                    //error.errorMessage == 'User cancelled the flow.' ? PopupWindow.showErrorMessage("Login", "User cancelled the 'Sign in with Microsoft' flow.") : PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
                }
            }
        }
    }

    HandelInteractionErrorbyMicrosoft(error) {
        // for user interaction errors due to slow network or login with non configured email display a generic message 
        //PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account.Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
        if (error.errorCode === "user_cancelled") {
            // dont show any error like PopupWindow.showErrorMessage("Login", "User cancelled the 'Sign in with Microsoft' flow.");
        }
        else if (error.errorCode === "popup_window_error") {
            // dont show any error PopupWindow.showErrorMessage("Login", "Error opening popup window.");
        }
        else if (error.errorCode === "monitor_window_timeout") {
            // dont show any error PopupWindow.showErrorMessage("Login", "monitor_window_timeout.");
        } else {
            PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account.Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
        }

    }
    ValidateUser() {
        this.setState({ showResetPasswordComponent: false });
        if ((this.state.Username != null && this.state.Username.trim() == "") && (this.state.Password != null && this.state.Password.trim() == "")) {
            PopupWindow.showErrorMessage("Login failed!", "Please enter username and password.");
        }
        else if (this.state.Username != null && this.state.Username.trim() == "") {
            PopupWindow.showErrorMessage("Login failed!", "Please enter username.");
        }
        else if (this.state.Password != null && this.state.Password.trim() == "") {
            PopupWindow.showErrorMessage("Login failed!", "Please enter password.");
        }
        else {
            $('.loader-global').show();
            //this.props.requestValidateUser(this.state.Username, this.state.Password);
            var url = Config.ApiBaseUrl + '/api/AuthUser/ValidateUser';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify({ "Username": this.state.Username, "Password": this.state.Password }), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.UserLoginDetails>)
                .then(data => {
                    if (data.Errmsg == null || data.Errmsg == "") {
                        this.setState({ loggedInUserData: data }, () => { this.SetLoadStateAndProcess(); });
                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFAUS") { 
                        $('#globalLoader').hide();
                        var strMFAUSMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/US 
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFAUSMessage.toString(), this.onOKMFA_US.bind(this));

                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFAUK") {
                        $('#globalLoader').hide();
                        var strMFAUKMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/UK 
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFAUKMessage.toString(), this.onOKMFA_UK.bind(this));
                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFACA") {
                        $('#globalLoader').hide();
                        var strMFACAMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/CA 
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFACAMessage.toString(), this.onOKMFA_CA.bind(this));
                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFAEU") {
                        $('#globalLoader').hide();
                        var strMFAEUMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/EU 
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFAEUMessage.toString(), this.onOKMFA_EU.bind(this));
                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFAAU") {
                        $('#globalLoader').hide();
                        var strMFAAUMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/AU
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFAAUMessage.toString(), this.onOKMFA_AU.bind(this));
                    }
                    else if (!Config.EnableNativeLogin && data.Errmsg == "showMFAJP") {
                        $('#globalLoader').hide();
                        var strMFAJPMessage = `Your organization now supports multifactor authentication (MFA) for the ORBCOMM Maritime Platform.<p>You have been directed to your organization’s regional homepage. For quick access to the Maritime Platform, please bookmark this page in your browser. The URL is shown below.</p>
                                                <input 
                                                    type="text" 
                                                    value=${window.location.origin}/JP 
                                                    readOnly 
                                                    class="readonly-mfa" 
                                                /> `;
                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Multifactor authentication (MFA)', strMFAJPMessage.toString(), this.onOKMFA_JP.bind(this));
                    }
                    else {
                        $('#globalLoader').hide();
                        PopupWindow.showErrorMessage("Login", data.Errmsg);

                    }
                });
        }
    }
    SetLoadStateAndProcess() {
        this.setState({ isLoading: false }, () => {
            if (!this.state.isLoading) {

                if (this.state.loggedInUserData != null) {

                    var userDetailInfo = JSON.parse(JSON.stringify(this.state.loggedInUserData));
                    if (userDetailInfo.User != null) {
                        if (userDetailInfo.User.ResetPassword && (userDetailInfo.Errmsg == null || userDetailInfo.Errmsg == "")) {
                            this.setState({ showResetPasswordComponent: true, renderResetPasswordHtml: this.renderResetPasswordPage() });
                            $('#globalLoader').hide();
                            return;//<div> {this.state.showResetPasswordComponent == true ? <ResetPassword userName={this.state.Username} /> : null}</div>;
                        }
                    }
                    if (!userDetailInfo.IsAccountLocked) {
                        if (userDetailInfo.Errmsg == null || userDetailInfo.Errmsg == "") {
                            this.setState({ IsLoggedIn: true, LoginAttempts: userDetailInfo.LoginAttempts, IsAccountLocked: userDetailInfo.IsAccountLocked });
                            this.cookieStore();
                            sessionStorage.setItem('JWTToken', userDetailInfo.JWTToken);
                            sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                            localStorage.setItem('login_status', 'logged_in' + '&' + this.state.Username);
                            sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                            var userInfo = JSON.stringify({
                                'Username': this.state.Username, 'IsAccountLocked': this.state.IsAccountLocked, 'IsLoggedIn': true, 'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision,
                                'LoginAttempts': this.state.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState, 'Auth0UserId': userDetailInfo.User.Auth0_UserId,
                                'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'Auth0Region': userDetailInfo.User.Customer.Auth0Region, 'Auth0_OrgId': userDetailInfo.User.Customer.Auth0_OrgId, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                            });
                            sessionStorage.setItem('UserInfo', userInfo);

                            if (userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Okta') && userDetailInfo.User.OKTASignInOverrideOption == "R") {
                                sessionStorage.setItem('UrlPath', userDetailInfo.User.Customer.URLpath);
                                $('#globalLoader').hide();
                                var strRedirectMessage = `Okta sign-in is required. You will now be redirected to your Okta sign-in page at ${window.location.origin}/${userDetailInfo.User.Customer.URLpath}.`;
                                RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in required', strRedirectMessage.toString(), this.onOKSubmitAllow.bind(this));
                            } else if (userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Azure') && userDetailInfo.User.AzureSignInOverrideOption == "R") {

                                $('#globalLoader').hide();
                                PopupWindow.showErrorMessage("Microsoft Sign-In Required", "Sign-In options have been limited by your local Maritime platform administrator. Please opt to 'Sign In with Microsoft'.");
                            }

                            else if ((userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Okta')) && (userDetailInfo.User.OKTASignInOverrideOption == "D") && (sessionStorage.getItem('okta-token-storage') != null)) {
                                $('#globalLoader').hide();
                                RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in disallowed', 'Okta sign-in is disallowed. You will now be redirected to the standard Maritime platform sign-in page at ' + window.location.origin, this.onOKSubmitDisAllow.bind(this));
                            }
                            else {

                                if (sessionStorage.getItem("QueryTag") != "" && sessionStorage.getItem("QueryTag") != null) {
                                    var queryTag = sessionStorage.getItem("QueryTag");

                                    if (queryTag.indexOf("?deviceId") > -1)
                                        this.props.history.push('/rcdstatus' + queryTag);
                                    else
                                        this.props.history.push('/home' + queryTag);
                                }
                                else
                                    if (!Config.EnableNativeLogin && userDetailInfo.User.Customer.Auth0Region != null && userDetailInfo.User.Customer.Auth0Region != "" && userDetailInfo.User.Customer.Auth0_OrgId != null && userDetailInfo.User.Customer.Auth0_OrgId != "") {
                                        sessionStorage.removeItem('region');
                                        sessionStorage.removeItem('JWTToken');
                                        sessionStorage.removeItem("userRights");
                                        localStorage.removeItem('login_status');
                                        sessionStorage.removeItem("customerDetails");
                                        sessionStorage.removeItem('UserInfo');
                                        sessionStorage.removeItem('OrbInit');
                                        var region = userDetailInfo.User.Customer.Auth0Region;
                                        region = region.replace(/"/g, '');
                                        window.location.href = "/" + region;
                                        //this.props.history.push('/' + region);

                                }
                                    else {

                                        sessionStorage.setItem('OrbInit', 'self');
                                        window.CoralogixRum.init({
                                            application: 'OMPAWSRCNG',
                                            environment: 'OMPAWSPROD',
                                            public_key: 'cxtp_Qf6s9h0gUZ2tB1ZZZHycWc88ekTixU',
                                            coralogixDomain: 'US2',
                                            version: '4.4.80',
                                            labels: {

                                                username: JSON.parse(sessionStorage.getItem('UserInfo') || '{}').Username || null,
                                            },

                                            sessionRecordingConfig: {
                                                enable: true,
                                                autoStartSessionRecording: true,
                                                recordConsoleEvents: true,
                                                sessionRecordingSampleRate: 100,
                                            },
                                        });
                                    this.props.history.push('/home');
                                }
                            }
                        }
                        else if (userDetailInfo.UserID == "0") {
                            $('#globalLoader').hide();
                        }
                        else if (userDetailInfo.LoginAttempts <= 5) {
                            //var attempsLeft = 5 - userDetailInfo.LoginAttempts;
                            $('#globalLoader').hide();
                        }
                        else {
                            $('#globalLoader').hide();
                        }
                    }
                    else {
                        $('#globalLoader').hide();
                    }
                    //  this.setState({ showResetPasswordComponent: false });
                }
            }
        });
    }
    disableResetPassword() {
        this.setState({
            showResetPasswordComponent: false,
            renderResetPasswordHtml: '',
            Username: '',
            Password: ''
        });
    }
    disableResetWindow() {
        this.setState({
            showResetPasswordComponent: false,
            renderResetPasswordHtml: '',
            Username: this.state.Username,
            Password: this.state.Password
        });
    }
    renderResetPasswordPage() {
        return <ResetPassword disableResetPassword={this.disableResetPassword.bind(this)} disableResetWindow={this.disableResetWindow.bind(this)} userName={this.state.Username} />;
    }
    onOKMFA_US(param: any) {
        sessionStorage.setItem('region', 'US');
        window.location.href = "/US";
    }
    onOKMFA_UK(param: any) {
        sessionStorage.setItem('region', 'UK');
        window.location.href = "/UK";
    }
    onOKMFA_EU(param: any) {
        sessionStorage.setItem('region', 'EU');
        window.location.href = "/EU";
    }
    onOKMFA_AU(param: any) {
        sessionStorage.setItem('region', 'AU');
        window.location.href = "/AU";
    }
    onOKMFA_JP(param: any) {
        sessionStorage.setItem('region', 'JP');
        window.location.href = "/JP";
    }
    onOKMFA_CA(param: any) {
        sessionStorage.setItem('region', 'CA');
        window.location.href = "/CA";
    }
    onOKSubmitAllow(param: any) {
        var redirectPath = "";
        if (sessionStorage.getItem("UrlPath") != null) {
            redirectPath = sessionStorage.getItem("UrlPath");
        }
        sessionStorage.removeItem("UserInfo");
        sessionStorage.removeItem("root");
        sessionStorage.removeItem('QueryTag');
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }
        //this.props.history.push("/" + redirectPath);
        window.location.href = "/" + redirectPath;
    }
    onOKSubmitDisAllow(param: any) {
        sessionStorage.removeItem("UserInfo");
        sessionStorage.removeItem("root");
        sessionStorage.removeItem('QueryTag');
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }
        window.location.href = "/";
    }
    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    componentWillReceiveProps(nextProps: any) {

        //if (!this.state.isLoading) {

        //    if (this.state.loggedInUserData != null) {

        //        var userDetailInfo = JSON.parse(JSON.stringify(this.state.loggedInUserData));
        //        if (userDetailInfo.User != null) {
        //            if (userDetailInfo.User.ResetPassword && (userDetailInfo.Errmsg == null || userDetailInfo.Errmsg == "")) {
        //                this.setState({ showResetPasswordComponent: true, renderResetPasswordHtml: this.renderResetPasswordPage() });
        //                $('#globalLoader').hide();
        //                return;//<div> {this.state.showResetPasswordComponent == true ? <ResetPassword userName={this.state.Username} /> : null}</div>;
        //            }
        //        }
        //        if (!userDetailInfo.IsAccountLocked) {
        //            if (userDetailInfo.Errmsg == null || userDetailInfo.Errmsg == "") {
        //                this.setState({ IsLoggedIn: true, LoginAttempts: userDetailInfo.LoginAttempts, IsAccountLocked: userDetailInfo.IsAccountLocked });
        //                this.cookieStore();
        //                sessionStorage.setItem('JWTToken', userDetailInfo.JWTToken);
        //                sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
        //                localStorage.setItem('login_status', 'logged_in' + '&' + this.state.Username);
        //                sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

        //                var userInfo = JSON.stringify({
        //                    'Username': this.state.Username, 'IsAccountLocked': this.state.IsAccountLocked, 'IsLoggedIn': true, 'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision,
        //                    'LoginAttempts': this.state.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
        //                    'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
        //                    'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
        //                    'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
        //                    'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide
        //                });
        //                sessionStorage.setItem('UserInfo', userInfo);

        //                if (userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Okta') && userDetailInfo.User.OKTASignInOverrideOption == "R") {
        //                    sessionStorage.setItem('UrlPath', userDetailInfo.User.Customer.URLpath);
        //                    $('#globalLoader').hide();
        //                    var strRedirectMessage = `Okta sign-in is required. You will now be redirected to your Okta sign-in page at ${window.location.origin}/${userDetailInfo.User.Customer.URLpath}.`;
        //                    RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in required', strRedirectMessage.toString(), this.onOKSubmitAllow.bind(this));
        //                } else if (userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Azure') && userDetailInfo.User.AzureSignInOverrideOption == "R") {

        //                    $('#globalLoader').hide();
        //                    PopupWindow.showErrorMessage("Microsoft Sign-In Required", "Sign-In options have been limited by your local Maritime platform administrator. Please opt to 'Sign In with Microsoft'.");
        //                }

        //                else if ((userDetailInfo.User.Customer.SSOSignInTypes != null && userDetailInfo.User.Customer.SSOSignInTypes.includes('Okta')) && (userDetailInfo.User.OKTASignInOverrideOption == "D") && (sessionStorage.getItem('okta-token-storage') != null)) {
        //                    $('#globalLoader').hide();
        //                    RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in disallowed', 'Okta sign-in is disallowed. You will now be redirected to the standard Maritime platform sign-in page at ' + window.location.origin, this.onOKSubmitDisAllow.bind(this));
        //                }
        //                else {

        //                    if (sessionStorage.getItem("QueryTag") != "" && sessionStorage.getItem("QueryTag") != null) {
        //                        var queryTag = sessionStorage.getItem("QueryTag");

        //                        if (queryTag.indexOf("?deviceId") > -1)
        //                            this.props.history.push('/rcdstatus' + queryTag);
        //                        else
        //                            this.props.history.push('/home' + queryTag);
        //                    }
        //                    else
        //                        this.props.history.push('/home');
        //                }
        //            }
        //            else if (userDetailInfo.UserID == "0") {
        //                $('#globalLoader').hide();
        //            }
        //            else if (userDetailInfo.LoginAttempts <= 5) {
        //                //var attempsLeft = 5 - userDetailInfo.LoginAttempts;
        //                $('#globalLoader').hide();
        //            }
        //            else {
        //                $('#globalLoader').hide();
        //            }
        //        }
        //        else {
        //            $('#globalLoader').hide();
        //        }
        //        //  this.setState({ showResetPasswordComponent: false });
        //    }
        //}
    }

    //setUserInfoSession(userSessionData: any) {
    //    sessionStorage.setItem('UserInfo', userSessionData);
    //    return "session created.";
    //}

    componentDidMount() {
        var preloader = document.getElementById("preloader");
        preloader.classList.add("hidden");
        if ($.cookie('uname') != null && $.cookie('uname') != "null") {
            var uname = $.cookie('uname');
            var password = $.cookie('pword');
            $('input[name=remember]').prop('checked', true);
            this.setState({
                Username: uname,
                Password: password,
            });
        }

        $(document).ready(function () {
            // var preloader = document.getElementById("preloader");
            // preloader.classList.add("hidden");

            //RCNG-3328 -Unable to Sign in from login page when hits "Enter" button in keyboard.
            $(document).keypress(function (e) {   
                if (e.keyCode === 13) {
                        $('#button_login').trigger('click');
                    }
            });
            //$('.login-form').bind('keypress', function (e) {
            //    if (e.keyCode === 13) {
            //        $('#button_login').trigger('click');
            //    }
            //});
        });
        //var s = document.createElement("script");
        //s.type = "text/javascript";
        //s.src = "https://www.bing.com/api/maps/mapcontrol?branch=release";
        //$("head").append(s);
        //this.checkUserLoggedInStatus();
        sessionStorage.setItem('DefaultSearch', 'enabled');

    }

    //checkUserLoggedInStatus() {      
    //axios.get("http://localhost:59591/", { withCredentials: true })
    //    .then(response => {                
    //        console.log("logged_in", response);
    //        if (!isNullOrUndefined(sessionStorage.getItem('UserInfo')))
    //            this.props.history.push('/home');
    //    })
    //    .catch(error =>
    //        console.log("check login error", error)
    //    );
    //}

    RedirectToForgotPassword() {
        this.props.history.push('/forgotpassword');
    }

    public render() {
        var divStyle = {
            backgroundImage: `url(${logo2})`
        }
        return <div className='login-bg img-responsive' style={divStyle}>
            <div className='login-form'>
                <div>
                    <div className='login-page-line'></div>
                    <div className='login-logo-maritime'>
                        <img src={OrbcommLogo11} alt="Maritime platform" className='login-page-logo' />
                        <span className='login-maritime'> MARITIME </span>
                    </div>
                </div>
                <form id='login-page'>

                    <div className="vstack gap-1 mx-auto">
                        <input type='text' id='txtUserName' name='UserName' className='form-control' value={this.state.Username} onChange={e => this.UsernameChange(e)} placeholder='Username' autoComplete='off' />
                        {/*<input type='password' id='txtPassWord' name='Password' className='form-control' value={this.state.Password} onChange={e => this.PasswordChange(e)} placeholder='Password' autoComplete='off' />*/}
                    </div>
                    <div className="form-group  mt-1">
                        <div className="input-group">
                            <input type='password' aria-label="txtPassWord" id='txtPassWord' name='Password' className='form-control' value={this.state.Password} onChange={e => this.PasswordChange(e)} placeholder='Password' autoComplete='off' />
                            <div className="input-group-text">
                                <span className="fas fa-eye-slash" id="spanPassword"
                                    onClick={this.handlePassword.bind(this)}></span>
                            </div>
                        </div>
                    </div>
                    <div className="form-check mt-2">
                        <input className="form-check-input" type="checkbox" name='remember' value="" id="chkremember" />
                        <label className="form-check-label" for="flexCheckDefault">
                            Remember me
                        </label>
                    </div>

                    <div className="d-grid">
                        <button type='button' id="button_login" data-bs-toggle="modal" data-bs-target="#resetPasswordModel" onClick={this.ValidateUser.bind(this)} className='btn btn-primary'>Sign In</button>
                    </div>

                    <a className='login-forgotpass' onClick={this.RedirectToForgotPassword.bind(this)}>Forgot password?</a>

                    <div className='signInDivider'> <span> or </span></div>

                    <button type='button' className='btn microsoftBtn' onClick={this.SignInWithAzureAD.bind(this)}>
                        <div>  <img src={SignIn} className='img-responsive' />  </div>
                        <span className='ms-2'> Sign in with Microsoft </span>

                    </button>

                </form>
            </div>
            <div className='login-footer'><span>© ORBCOMM {(new Date().getFullYear())} All Rights Reserved</span></div>
            <div>
                {this.state.renderResetPasswordHtml}
            </div>
        </div>;
    }
}


//export default connect(
//    (state: ApplicationState) => state.userDetails, // Selects which state properties are merged into the component's props
//    UserDetailState.actionCreators    // Selects which action creators are merged into the component's props
//)(UserLogin as any);


